<template>
  <el-dialog
    :title="$t('allocationOrder.auditInfo')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="auditInfo" label-width="120px">
      <el-form-item :label="$t('allocationOrder.auditStatus')" prop="state" :rules="[{ required: true, message: $t('allocationOrder.selectAuditStatus'), trigger: 'change' }]">
        <el-select
          v-model="auditInfo.state"
          :placeholder="$t('allocationOrder.selectAuditStatus')"
          style="width:100%"
          @change="handleStateChange"
        >
          <el-option
            :label="$t('allocationOrder.agree')"
            value="2002"
          />
          <el-option
            :label="$t('allocationOrder.reject')"
            value="3003"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('allocationOrder.reason')" prop="remark" :rules="[{ required: true, message: $t('allocationOrder.inputReason'), trigger: 'blur' }]">
        <el-input
          v-model="auditInfo.remark"
          type="textarea"
          :placeholder="$t('allocationOrder.inputReason')"
          :rows="4"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading">{{ $t('common.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { auditAllocationOrder } from '@/api/goods/allocationOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AllocationOrderAudit',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      orderData: null,
      auditInfo: {
        state: '',
        remark: ''
      }
    }
  },
  methods: {
    open(order) {
      this.orderData = order
      this.resetForm()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    resetForm() {
      this.auditInfo = {
        state: '',
        remark: ''
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleStateChange(val) {
      if (val === '2002') {
        this.auditInfo.remark = this.$t('allocationOrder.agree')
      } else {
        this.auditInfo.remark = ''
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        
        if (!this.orderData) {
          this.$message.error('订单数据不存在')
          return
        }

        this.loading = true
        
        // 构造审核数据
        const auditData = {
          ...this.orderData,
          state: this.auditInfo.state,
          stateRemark: this.auditInfo.remark,
          flag: '1',
          shopId: getShopId()
        }

        const res = await auditAllocationOrder(auditData)
        
        this.$message.success(res.msg || this.$t('allocationOrder.auditSuccess'))
        this.handleClose()
        this.$emit('refresh')
      } catch (error) {
        if (error.message) {
          this.$message.error(error.message)
        } else {
          console.error('审核失败:', error)
          this.$message.error(error || '审核失败')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>

